<template>
  <div>
    <div v-show="isShowSelect"
         class="mask"
         @click="isShowSelect = !isShowSelect" />
    <el-popover ref="popover"
                class="ztreePopover"
                v-model="isShowSelect"
                placement="bottom-start"
                :width="width"
                trigger="manual">
      <el-input :placeholder="options.searchPlaceholder"
                :size="size"
                style="margin-bottom:10px"
                v-model="filterText"
                @change="searchChange">
      </el-input>

      <ul :id="treeDomId"
          ref="catSelectTree"
          v-show="!isSearchTree"
          class="ztree"
          :style="style"
          style="overflow-y: auto;"
          @select="zTreeOnClick"></ul>
      <ul :id="treeDomSearchId"
          class="ztree"
          v-if="isSearchTree"
          :style="style"
          style="overflow-y: auto;"
          @select="zTreeOnClick"></ul>
      <el-select slot="reference"
                 ref="select"
                 v-model="treeSelectedData"
                 :placeholder="placeholder"
                 :disabled="isDisabled"
                 :style="selectStyle"
                 :size="size"
                 :multiple="multiple"
                 :collapse-tags="multiple"
                 v-bind="$attrs"
                 v-on="$listeners"
                 class="tree-select"
                 :clearable="false"
                 @remove-tag="removeTag"
                 @clear="clearNode"
                 @click.native="isShowSelect = !isShowSelect"
                 @change="changeSelect">
        <el-option v-for="item in selectOptions"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id" />
      </el-select>
    </el-popover>
  </div>
</template>

<script>
import '@/libs/js/jquery.ztree.core.js'
import '@/libs/js/jquery.ztree.excheck.js'
// import '@/libs/css/zTreeStyle.css'
import '@/libs/css/treeSelectStyle.css'
import { getObjFromUrl } from '@/utils'

export default {
  name: 'zTree',
  model: {
    prop: 'treeSelectValue',
    event: 'change',
  },
  props: {
    // 选择的值
    treeSelectValue: {
      type: Array,
      default() {
        return []
      },
    },
    size: {
      type: String,
      default() {
        return 'mini'
      },
    },
    width: {
      type: Number,
      default() {
        return 450
      },
    },
    height: {
      type: Number,
      default() {
        return 300
      },
    },
    treeDomId: {
      type: String,
      default() {
        return 'selectZtree'
      },
    },
    treeDomSearchId: {
      type: String,
      default() {
        return 'searchTree'
      },
    },
    plat: {
      type: String,
      default: 'all',
    },
    checkedKeys: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'default',
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    this.catsData = {}
    this.zTreeObj = {}
    this.zNodes = []
    return {
      placeholder: this.$t('headSearch.form_category_loading'),
      isSearchTree: false, //是否展示搜索后的tree
      style:
        'width:' + (this.width - 20) + 'px;' + 'height:' + this.height + 'px;',
      selectStyle: 'width:' + (this.width - 20) + 'px;font-size: 12px',
      filterText: '',
      isShowSelect: false, // 是否显示树状选择器
      selectedData: '[]', // 选中的节点
      treeSelectedData: [], // 选中的节点
      selectOptions: [],
      setting: {
        treeId: 'id',
        data: {
          key: {
            name: 'label',
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: 0,
          },
        },
        view: {
          showIcon: false,
          //   showLine: false,
          fontCss: this.zTreefontCss,
          nodeClasses: this.zTreeNodeClasses,
        },
        check: {
          enable: true,
          chkStyle: 'checkbox',
          radioType: 'all',
          autoCheckTrigger: false,
          chkDisabledInherit: false,
          nocheckInherit: false,
          chkboxType: { Y: 'ps', N: 'ps' },
        },
        callback: {
          onClick: this.zTreeOnClick,
          onCheck: this.zTreeOnCheck,
          beforeClick: this.zTreeBeforeClick,
        },
      },
      searchSetting: {
        treeId: 'id',
        async: {
          enable: false,
          url: '',
          autoParam: ['id'],
        },
        data: {
          key: {
            name: 'label',
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: 0,
          },
        },
        view: {
          showIcon: false,
          //   showLine: false,
          fontCss: this.zTreeSearchfontCss,
          nodeClasses: this.zTreeSearchNodeClasses,
        },
        check: {
          enable: true,
          chkStyle: 'checkbox',
          radioType: 'all',
          autoCheckTrigger: false,
          chkDisabledInherit: false,
          nocheckInherit: false,
          chkboxType: { Y: 'ps', N: 'ps' },
        },
        callback: {
          onClick: this.zTreeSearchOnClick,
          onCheck: this.zTreeSearchOnCheck,
          beforeClick: this.zTreeBeforeClick,
        },
      },
      options: {
        searchShowParent: true,
        searchPlaceholder: this.$t('headSearch.form_category_search_holder'),
        searchKeys: null,
      },
      searchTime: null,
      isDisabled: true,
      langModeChange: false,
    }
  },
  watch: {
    treeSelectValue: {
      handler(value) {
        // this.selectedData = this.treeSelectValue
      },
      deep: true,
    },
    // selectedData: {
    //   handler(value) {
    //     this.treeSelectedData = this.selectedData[0]
    //     this.$nextTick(() => {
    //       this.$refs.popover.updatePopper()
    //       // 注意主要是这里
    //     })
    //   },
    //   deep: true,
    // },
    loginInfo(newVal) {
      // 类目展示数据依赖用户权限信息,只有用户信息有值时才加载类目数据
      const cat_list = newVal.cat_list
      const jd_cat_list = newVal.jd_cat_list
      if (newVal.is_validata_user_count) {
        this.loadCats()
        return
      }
      if (this.plat == 'gamazon' || this.type == 'social') {
        this.loadCats()
        return
      }
      if (this.plat == 'douyin') {
        this.loadCats()
        return
      }
      if (cat_list != 'all') {
        let hasCatList = false
        for (let key in cat_list) {
          if (cat_list[key].length > 0) {
            hasCatList = true
            break
          }
        }
        if (!hasCatList) {
          this.$emit('ChangeJdPlat')
          return
        }
      }
      if (jd_cat_list != 'all') {
        let hasCatList = false
        for (let key in jd_cat_list) {
          if (jd_cat_list[key].length > 0) {
            hasCatList = true
            break
          }
        }
        if (!hasCatList) {
          this.$emit('ChangeAllPlat')
          return
        }
      }
      this.loadCats()
      // this.treeSelectedData = this.treeSelectValue
    },
    isShowSelect(val) {
      // 隐藏select自带的下拉框
      this.isSearchTree = false
      this.$refs.select.visible = false
      if (val) {
        this.filterText = ''
        let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
        if (this.treeSelectValue.length > 0 && this.treeSelectValue[0] != '') {
          let node = zTree.getNodeByParam('id', this.treeSelectValue[0])
          zTree.selectNode(node)
          let target = document.getElementById(node.tId)
          this.$nextTick(() => {
            let targetTop = 0
            if (target.offsetTop > 200) {
              targetTop = target.offsetTop - 200
            }
            this.$refs.catSelectTree.scrollTo(0, targetTop)
          })
        }
      } else {
        let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
        // zTree.expandAll(false)
        if (this.treeSelectValue.length > 0 && this.treeSelectValue[0] != '') {
          let node = zTree.getNodeByParam('id', this.treeSelectValue[0])
          this.selectOptions = [
            {
              id: node.id,
              name: node.label,
            },
          ]
        }
      }
      this.$refs.select.blur()
    },
    plat: {
      handler(newVal) {
        this.zNodes = []
        this.loadCatsDebounce()
      },
    },
    '$store.state.user.languageMode': {
      handler(newVal) {
        this.langModeChange = true
        this.zNodes = []
        this.loadCatsDebounce()
      },
    },
    // checkedKeys(val) {
    //   if (!val) return
    //   // this.checkedKeys = val
    //   this.initCheckedData()
    // },
  },
  computed: {
    loginCatList() {
      switch (this.plat) {
        case 'amazon_jp':
          return this.$store.state.user.amazonJpLoginCatList
        case 'amazon_uk':
          return this.$store.state.user.amazonUkLoginCatList
        case 'amazon_de':
          return this.$store.state.user.amazonDeLoginCatList
        case 'shopee_sg':
          return this.$store.state.user.shopeeSgLoginCatList
        case 'shopee_ph':
          return this.$store.state.user.shopeePhLoginCatList
        case 'shopee_my':
          return this.$store.state.user.shopeeMyLoginCatList
        case 'shopee_vn':
          return this.$store.state.user.shopeeVnLoginCatList
        case 'shopee_th':
          return this.$store.state.user.shopeeThLoginCatList
        case 'shopee_id':
          return this.$store.state.user.shopeeIdLoginCatList
        case 'lazada_my':
          return this.$store.state.user.lazadaMyLoginCatList
        case 'lazada_sg':
          return this.$store.state.user.lazadaSgLoginCatList
        case 'lazada_id':
          return this.$store.state.user.lazadaIdLoginCatList
        case 'lazada_ph':
          return this.$store.state.user.lazadaPhLoginCatList
        case 'lazada_th':
          return this.$store.state.user.lazadaThLoginCatList
        case 'lazada_vn':
          return this.$store.state.user.lazadaVnLoginCatList
        case 'gamazon':
          return this.$store.state.user.amazonLoginCatList
        case 'chance_all':
          return this.$store.state.user.chanceLoginCatList
        case 'chance_jd':
          return this.$store.state.user.chanceJdLoginCatList
        case 'jd':
          return this.$store.state.user.jdLoginCatList
        default:
          return this.$store.state.user.loginCatList
      }
      // return 'notAll'
    },
    amazonJpLoginCatList() {
      return this.$store.state.user.amazonJpLoginCatList
    },
    amazonJpLoginCatlevel() {
      return this.$store.state.user.amazonJpLoginCatlevel
    },
    amazonUkLoginCatList() {
      return this.$store.state.user.amazonUkLoginCatList
    },
    amazonUkLoginCatlevel() {
      return this.$store.state.user.amazonUkLoginCatlevel
    },
    amazonDeLoginCatList() {
      return this.$store.state.user.amazonDeLoginCatList
    },
    amazonDeLoginCatlevel() {
      return this.$store.state.user.amazonDeLoginCatlevel
    },
    lazadaMyLoginCatList() {
      return this.$store.state.user.lazadaMyLoginCatList
    },
    lazadaMyLoginCatLevel() {
      return this.$store.state.user.lazadaMyLoginCatLevel
    },
    lazadaSgLoginCatList() {
      return this.$store.state.user.lazadaSgLoginCatList
    },
    lazadaSgLoginCatLevel() {
      return this.$store.state.user.lazadaSgLoginCatLevel
    },
    lazadaIdLoginCatList() {
      return this.$store.state.user.lazadaIdLoginCatList
    },
    lazadaIdLoginCatLevel() {
      return this.$store.state.user.lazadaIdLoginCatLevel
    },
    lazadaPhLoginCatList() {
      return this.$store.state.user.lazadaPhLoginCatList
    },
    lazadaPhLoginCatLevel() {
      return this.$store.state.user.lazadaPhLoginCatLevel
    },
    lazadaThLoginCatList() {
      return this.$store.state.user.lazadaThLoginCatList
    },
    lazadaThLoginCatLevel() {
      return this.$store.state.user.lazadaThLoginCatLevel
    },
    lazadaVnLoginCatList() {
      return this.$store.state.user.lazadaVnLoginCatList
    },
    lazadaVnLoginCatLevel() {
      return this.$store.state.user.lazadaVnLoginCatLevel
    },
    shopeeSgLoginCatList() {
      return this.$store.state.user.shopeeSgLoginCatList
    },
    shopeeSgLoginCatlevel() {
      return this.$store.state.user.shopeeSgLoginCatlevel
    },
    shopeePhLoginCatList() {
      return this.$store.state.user.shopeePhLoginCatList
    },
    shopeePhLoginCatlevel() {
      return this.$store.state.user.shopeePhLoginCatlevel
    },
    shopeeMyLoginCatList() {
      return this.$store.state.user.shopeeMyLoginCatList
    },
    shopeeMyLoginCatlevel() {
      return this.$store.state.user.shopeeMyLoginCatlevel
    },
    shopeeVnLoginCatList() {
      return this.$store.state.user.shopeeVnLoginCatList
    },
    shopeeVnLoginCatlevel() {
      return this.$store.state.user.shopeeVnLoginCatlevel
    },
    shopeeThLoginCatList() {
      return this.$store.state.user.shopeeThLoginCatList
    },
    shopeeThLoginCatlevel() {
      return this.$store.state.user.shopeeThLoginCatlevel
    },
    shopeeIdLoginCatList() {
      return this.$store.state.user.shopeeIdLoginCatList
    },
    shopeeIdLoginCatlevel() {
      return this.$store.state.user.shopeeIdLoginCatlevel
    },
    amazonLoginCatList() {
      return this.$store.state.user.amazonLoginCatList
      // return 'notAll'
    },
    amazonLoginCatlevel() {
      return this.$store.state.user.amazonLoginCatlevel
      // return 'notAll'
    },
    douyinLoginCatList() {
      return this.$store.state.user.douyinLoginCatList
      // return 'notAll'
    },
    douyinLoginCatlevel() {
      return this.$store.state.user.douyinLoginCatlevel
      // return 'notAll'
    },
    loginCatLevel() {
      return this.$store.state.user.loginCatlevel
      // return this.cat_list
    },
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
  },
  created() {
    // 存储各平台树结构
    if (!window.treeObj) {
      window.treeObj = {
        all: [],
        jd: [],
        gamazon: [],
        // tbjd: [],
        shopee_id: [],
        shopee_th: [],
        shopee_vn: [],
        shopee_my: [],
        shopee_ph: [],
        shopee_sg: [],
        lazada_my: [],
        lazada_sg: [],
        lazada_id: [],
        lazada_ph: [],
        lazada_th: [],
        lazada_vn: [],
        amazon_de: [],
        amazon_uk: [],
        amazon_jp: [],
        chance_all: [],
        chance_jd: [],
        douyin: [],
        tbjddy: [],
      }
    }
    this.loadCatsDebounce = _.debounce(() => {
      this.loadCats()
    }, 100)
    if (!this.multiple) {
      this.setting.check.enable = false
      this.searchSetting.check.enable = false
    }
    // 类目展示数据依赖用户权限信息,只有用户信息有值时才加载类目数据
    if (
      this.loginInfo.cat_list &&
      Object.keys(this.loginInfo.cat_list).length > 0
    ) {
      const cat_list = this.loginInfo.cat_list
      const jd_cat_list = this.loginInfo.jd_cat_list
      if (this.loginInfo.is_validata_user_count) {
        this.loadCats()
        return
      }
      if (this.plat == 'gamazon' || this.type == 'social') {
        this.loadCats()
        return
      }
      if (this.plat == 'douyin') {
        this.loadCats()
        return
      }
      if (cat_list != 'all') {
        let hasCatList = false
        for (let key in cat_list) {
          if (cat_list[key].length > 0) {
            hasCatList = true
            break
          }
        }
        if (!hasCatList) {
          this.$emit('ChangeJdPlat')
          return
        }
      }
      if (jd_cat_list != 'all') {
        let hasCatList = false
        for (let key in jd_cat_list) {
          if (jd_cat_list[key].length > 0) {
            hasCatList = true
            break
          }
        }
        if (!hasCatList) {
          this.$emit('ChangeAllPlat')
          return
        }
      }
      this.loadCats()
      // this.treeSelectedData = this.treeSelectValue;
    }
  },
  mounted() {},
  methods: {
    zTreefontCss(treeId, treeNode) {
      if (treeNode.disabled) {
        return { color: '#7D8A9B' }
      }
      // if (treeNode.isParent) {
      //   // if (this.ifHit(treeNode, this.filterText, [])) {
      //   //   return { color: '#85868A' }
      //   // }else {
      //   //   return { color: '#337ab7' }
      //   // }
      //   return { color: '#337ab7' }
      // } else {
      //   return { color: '#337ab7' }
      // }
    },
    zTreeSearchfontCss(treeId, treeNode) {
      // if (treeNode.isParent) {
      //   // return { color: '#337ab7' }
      //   return { color: '#337ab7' }
      // } else {
      //   // return { color: '#337ab7' }
      //   return { color: '#337ab7'}
      // }
      if (treeNode.isSearchNode) {
        return { color: '#dc1d35' }
      }
    },
    // zTreeNodeClasses(treeId, treeNode) {
    //   let _this = this
    //   let add = []
    //   if (_this.ifHit(treeNode, this.treeSelectedData, [])) {
    //     add.push('search-hit-node')
    //   }
    //   return { add: add }
    // },
    zTreeSearchNodeClasses(treeId, treeNode) {
      let _this = this
      let add = []
      if (_this.ifHit(treeNode, this.treeSelectedData, [])) {
        add.push('search-hit-node')
      }
      return { add: add }
    },
    ifHit(node, keyWord, serverSearchData) {
      serverSearchData = serverSearchData || []
      let _this = this
      if (
        _this.options.searchKeys instanceof Array &&
        _this.options.searchKeys.length > 0
      ) {
        let flag = false
        $(_this.options.searchKeys).each(function (index, item) {
          if (item.startsWith('like_')) {
            if (node[item.replace('like_', '')].indexOf(keyWord) != -1) {
              flag = true
              return
            }
          } else if (item.startsWith('eq_')) {
            if (node[item.replace('eq_', '')] === keyWord) {
              flag = true
              return
            }
          }
        })
        return flag
      } else {
        return (
          node[_this.setting.data.key.name].indexOf(keyWord) != -1 ||
          _.includes(serverSearchData, node.id)
        )
      }
    },
    zTreeOnClick(event, treeId, treeNode) {
      if (treeNode.disabled) {
        return
      }
      this.selectOptions = [
        {
          id: treeNode.id,
          name: treeNode.label,
        },
      ]
      this.treeSelectedData = treeNode.id
      this.isShowSelect = false
      this.$emit('cidChange', this.selectOptions)
      this.$emit('change', [this.treeSelectedData])
      let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      zTree.checkNode(treeNode, !treeNode.checked, true)
    },
    zTreeSearchOnClick(event, treeId, treeNode) {
      this.selectOptions = [
        {
          id: treeNode.id,
          name: treeNode.label,
        },
      ]
      this.treeSelectedData = treeNode.id
      this.isShowSelect = false
      this.$emit('cidChange', this.selectOptions)
      this.$emit('change', [this.treeSelectedData])
      //   let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      //   zTree.checkNode(treeNode, !treeNode.checked, true)
    },
    zTreeSearchOnCheck(event, treeId, treeNode) {
      let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      let node = zTree.getNodeByParam('id', treeNode.id)
      zTree.checkNode(node, treeNode.checked, true)

      this.zTreeOnCheck()
    },
    zTreeOnCheck(event, treeId, treeNode) {
      let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      // zTree.cancelSelectedNode()
      // zTree.selectNode(treeNode)
      let checkedNodes = zTree.getChangeCheckedNodes()
      let ignoreIds = []
      const selectIds = []
      const selectOptions = []
      checkedNodes.forEach((item) => {
        // 该节点被全选且父节点未被选中,则子节点id不传入
        if (item.check_Child_State == 2 && ignoreIds.indexOf(item.id) == -1) {
          selectIds.push(item.id)
          // let node = zTree.getNodeByParam('id', item.id)
          // zTree.selectNode(node,true,true)
          selectOptions.push({
            id: item.id,
            name: item.label,
          })
          ignoreIds.push(...this.getChdNodesIds(item))
        }
        // 父节点不是全选,子节点没有children
        else if (
          item.check_Child_State == -1 &&
          ignoreIds.indexOf(item.id) == -1
        ) {
          selectIds.push(item.id)
          // let node = zTree.getNodeByParam('id', item.id)
          // zTree.selectNode(node,true,true)
          selectOptions.push({
            id: item.id,
            name: item.label,
          })
        }
      })
      // 设置选择的节点
      const selectNodesIds = zTree.getSelectedNodes().map((item) => item.id)
      selectIds.forEach((id) => {
        if (selectNodesIds.indexOf(id) == -1) {
          let node = zTree.getNodeByParam('id', id)
          zTree.selectNode(node, true, true)
        }
      })
      selectNodesIds.forEach((id) => {
        if (selectIds.indexOf(id) == -1) {
          let node = zTree.getNodeByParam('id', id)
          zTree.cancelSelectedNode(node)
        }
      })
      this.treeSelectedData = selectIds
      this.selectOptions = selectOptions
      this.$emit('change', this.treeSelectedData)
    },
    getChdNodesIds(nodes) {
      const ids = []
      if (nodes.children && nodes.children.length > 0) {
        nodes.children.forEach((item) => {
          ids.push(item.id)
          if (item.children && item.children.length > 0) {
            ids.push(...this.getChdNodesIds(item))
          }
        })
      }
      return ids
    },
    zTreeBeforeClick(treeId, treeNode) {
      return !this.multiple
    },
    // zTreeBeforeCheck(treeId, treeNode) {
    //   return !treeNode.isParent //当是父节点 返回false 不让选取
    // },
    clearNode() {
      this.$emit('clear')
      let treeObj = $.fn.zTree.getZTreeObj(this.treeDomId)
      treeObj.cancelSelectedNode()
      this.treeSelectedData = []
      this.isShowSelect = false
    },
    changeSelect() {},
    searchChange(value) {
      if (value.trim() !== '') {
        this.isSearchTree = true
        this.doSearch(value)
      } else {
        this.isSearchTree = false
      }
    },
    doSearch(searchWord) {
      let _this = this
      /*异步执行低频率执行解决性能问题*/
      if (_this.searchTime) {
        clearTimeout(_this.searchTime)
      }
      _this.searchTime = setTimeout(function () {
        let serverSearch =
          _this.options.serverSearch ||
          function () {
            return new Promise(function (resolve, reject) {
              resolve(null)
            })
          }
        serverSearch(searchWord).then(function (serverSearchData) {
          let searchzTreeObj = _this.zTreeObj
          let nodeList = searchzTreeObj.getNodesByFilter(function (node) {
            return _this.ifHit(node, searchWord, serverSearchData)
          }) //通过关键字模糊搜索
          let datasMap = {}
          $(nodeList).each(function (index, item) {
            item.isSearchNode = true
            datasMap[item['id']] = item
          })
          if (_this.options.searchShowParent) {
            $(nodeList).each(function (index, node) {
              _this.loadParents(node, datasMap)
            })
          }
          let _zNodes = _.values(datasMap)
          _this.initSearchTree(_zNodes, searchWord, serverSearchData)
        })
      }, 200)
    },
    loadParents(node, datasMap) {
      let parent = node.getParentNode()
      if (parent) {
        let copyparent = $.extend({}, parent)
        copyparent.children = null
        copyparent.open = true
        datasMap[parent['id']] = copyparent
        this.loadParents(parent, datasMap)
      } else {
        return
      }
    },
    initSearchTree(data) {
      let _this = this
      $.fn.zTree.init($('#' + this.treeDomSearchId), _this.searchSetting, data)
    },
    async loadCats() {
      // if (this.type != 'search') {
      //   this.$eventBus.$emit('loadingCats', true)
      // }
      let rawData = await this.loadSiteCats()
      this.catsData = rawData
      this.$emit('ChildrenListLoaded', this.catsData.result.childrenList)
      this.getData()
    },
    loadSiteCats() {
      return new Promise((resolve, reject) => {
        try {
          if (
            (this.plat == 'all' ||
              this.plat == 'chance_all' ||
              this.plat == 'tbjddy') &&
            !window.cache_cat
          ) {
            // 加载淘系类目数据
            const s = document.createElement('script')
            s.type = 'text/javascript'
            s.src = 'https://staticjs.mktindex.com/prod/bigcats_taobao.js'
            document.body.appendChild(s)
            s.onload = function () {
              window.cache_cat = window.cache_cat || window.cache_cat_taobao
              let datas = window.cache_cat
              resolve(datas)
            }
          } else if (
            (this.plat == 'jd' || this.plat == 'chance_jd') &&
            !window.cache_cat_jd
          ) {
            // 加载京东类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://comment.mktindex.com/static/lingting/json/bigcats_jd.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_cat_jd
              resolve(datas)
            }
          } else if (this.plat == 'douyin' && !window.cache_douyin_cats) {
            // 加载抖音类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://staticjs.mktindex.com/prod/bigcats_douyin.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_douyin_cats
              resolve(datas)
            }
          } else if (
            this.plat == 'gamazon' &&
            !window.cache_cat_oversea_amazon_us
          ) {
            // 加载亚马逊类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/oversea_amazon_us.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_cat_oversea_amazon_us
              resolve(datas)
            }
          } else if (
            this.plat == 'amazon_de' &&
            !window.cache_cat_oversea_amazon_de
          ) {
            // 加载亚马逊德国类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/oversea_amazon_de.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_cat_oversea_amazon_de
              resolve(datas)
            }
          } else if (
            this.plat == 'amazon_uk' &&
            !window.cache_cat_oversea_amazon_uk
          ) {
            // 加载亚马逊英国类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/oversea_amazon_uk.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_cat_oversea_amazon_uk
              resolve(datas)
            }
          } else if (
            this.plat == 'amazon_jp' &&
            !window.cache_cat_oversea_amazon_jp
          ) {
            // 加载亚马逊日本类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/oversea_amazon_jp.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let datas = window.cache_cat_oversea_amazon_jp
              resolve(datas)
            }
          } else if (
            this.plat == 'shopee_id' &&
            !window.cache_cat_oversea_shopee_id
          ) {
            //加载shopee_id类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_shopee_id.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_shopee_id
              resolve(data)
            }
          } else if (
            this.plat == 'shopee_th' &&
            !window.cache_cat_oversea_shopee_th
          ) {
            //加载shopee_th类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_shopee_th.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_shopee_th
              resolve(data)
            }
          } else if (
            this.plat == 'shopee_vn' &&
            !window.cache_cat_oversea_shopee_vn
          ) {
            //加载shopee_vn类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_shopee_vn.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_shopee_vn
              resolve(data)
            }
          } else if (
            this.plat == 'shopee_my' &&
            !window.cache_cat_oversea_shopee_my
          ) {
            //加载shopee_my类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_shopee_my.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_shopee_my
              resolve(data)
            }
          } else if (
            this.plat == 'shopee_ph' &&
            !window.cache_cat_oversea_shopee_ph
          ) {
            //加载shopee_ph类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_shopee_ph.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_shopee_ph
              resolve(data)
            }
          } else if (
            this.plat == 'shopee_sg' &&
            !window.cache_cat_oversea_shopee_sg
          ) {
            //加载shopee_sg类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_shopee_sg.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_shopee_sg
              resolve(data)
            }
          } else if (
            this.plat == 'lazada_my' &&
            !window.cache_cat_oversea_lazada_my
          ) {
            //加载lazada_my类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_lazada_my.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_lazada_my
              resolve(data)
            }
          } else if (
            this.plat == 'lazada_sg' &&
            !window.cache_cat_oversea_lazada_sg
          ) {
            //加载lazada_sg类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_lazada_sg.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_lazada_sg
              resolve(data)
            }
          } else if (
            this.plat == 'lazada_id' &&
            !window.cache_cat_oversea_lazada_id
          ) {
            //加载lazada_id类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_lazada_id.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_lazada_id
              resolve(data)
            }
          } else if (
            this.plat == 'lazada_ph' &&
            !window.cache_cat_oversea_lazada_ph
          ) {
            //加载lazada_ph类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_lazada_ph.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_lazada_ph
              resolve(data)
            }
          } else if (
            this.plat == 'lazada_th' &&
            !window.cache_cat_oversea_lazada_th
          ) {
            //加载lazada_th类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_lazada_th.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_lazada_th
              resolve(data)
            }
          } else if (
            this.plat == 'lazada_vn' &&
            !window.cache_cat_oversea_lazada_vn
          ) {
            //加载lazada_vn类目数据
            const s_jd = document.createElement('script')
            s_jd.type = 'text/javascript'
            s_jd.src =
              'https://chance.mktindex.com/static/chance/json/bigcats_lazada_vn.js'
            document.body.appendChild(s_jd)
            s_jd.onload = function () {
              let data = window.cache_cat_oversea_lazada_vn
              resolve(data)
            }
          } else {
            let datas
            switch (this.plat) {
              case 'chance_jd':
              case 'jd':
                datas = window.cache_cat_jd
                break
              case 'chance_all':
              case 'all':
                datas = window.cache_cat
                break
              case 'gamazon':
                datas = window.cache_cat_oversea_amazon_us
                break
              case 'amazon_de':
                datas = window.cache_cat_oversea_amazon_de
                break
              case 'amazon_uk':
                datas = window.cache_cat_oversea_amazon_uk
                break
              case 'amazon_jp':
                datas = window.cache_cat_oversea_amazon_jp
                break
              case 'shopee_id':
                datas = window.cache_cat_oversea_shopee_id
                break
              case 'shopee_th':
                datas = window.cache_cat_oversea_shopee_th
                break
              case 'shopee_vn':
                datas = window.cache_cat_oversea_shopee_vn
                break
              case 'shopee_my':
                datas = window.cache_cat_oversea_shopee_my
                break
              case 'shopee_ph':
                datas = window.cache_cat_oversea_shopee_ph
                break
              case 'shopee_sg':
                datas = window.cache_cat_oversea_shopee_sg
                break
              case 'lazada_my':
                datas = window.cache_cat_oversea_lazada_my
                break
              case 'lazada_sg':
                datas = window.cache_cat_oversea_lazada_sg
                break
              case 'lazada_id':
                datas = window.cache_cat_oversea_lazada_id
                break
              case 'lazada_ph':
                datas = window.cache_cat_oversea_lazada_ph
                break
              case 'lazada_th':
                datas = window.cache_cat_oversea_lazada_th
                break
              case 'lazada_vn':
                datas = window.cache_cat_oversea_lazada_vn
                break
              case 'douyin':
                datas = window.cache_douyin_cats
                break
              default:
                datas = window.cache_cat
            }
            resolve(datas)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    // 判断是否为social跳转的不限制10个重点类目
    isSocialCatList(tree, socialCatList) {
      const treeLength = tree.length
      if (treeLength > 0 && treeLength == socialCatList.length + 1) {
        let isAll = false
        let isSocialCatList = true
        if (tree[treeLength - 1].id == '0') {
          isAll = true
          tree.splice(treeLength - 1, 1)
        }
        if (isAll) {
          for (let i = 0; i < tree.length; i++) {
            const item = tree[i]
            if (item.id !== socialCatList[i]) {
              isSocialCatList = false
              break
            }
          }
        } else {
          isSocialCatList = false
        }
        return isSocialCatList
      } else {
        return false
      }
    },
    async getData() {
      let arrs = []
      if (this.langModeChange && this.type !== 'social') {
        arrs = this.catsData.result.bigCategory
        this.startWorker(arrs).then((res) => {
          this.zNodes = res
          this.isDisabled = false
          window.treeObj[this.plat] = res
          this.initSelectzTree()
        })
      } else if (this.loginCatList == 'all' && this.type !== 'social') {
        arrs = this.catsData.result.bigCategory
        let isSocialCatList = this.isSocialCatList(
          window.treeObj[this.plat],
          this.loginInfo.social_cat_list
        )
        if (window.treeObj[this.plat].length > 0 && !isSocialCatList) {
          setTimeout(() => {
            this.zNodes = window.treeObj[this.plat]
            this.isDisabled = false
            this.initSelectzTree()
          }, 200)
        } else {
          this.startWorker(arrs).then((res) => {
            this.zNodes = res
            this.isDisabled = false
            window.treeObj[this.plat] = res
            this.initSelectzTree()
          })
        }
        // this.zNodes = this.transformPickerOptions(arrs)
        // this.initSelectzTree()
      } else if (this.plat == 'gamazon') {
        if (this.amazonLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.gamazon_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.gamazon_cat_list).forEach((v) => {
              this.loginInfo.gamazon_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.gamazon_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'amazon_de') {
        if (this.amazonDeLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.amazon_de_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.amazon_de_cat_list).forEach((v) => {
              this.loginInfo.amazon_de_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.amazon_de_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'amazon_uk') {
        if (this.amazonUkLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.amazon_uk_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.amazon_uk_cat_list).forEach((v) => {
              this.loginInfo.amazon_uk_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.amazon_uk_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'amazon_jp') {
        if (this.amazonJpLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.amazon_jp_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.amazon_jp_cat_list).forEach((v) => {
              this.loginInfo.amazon_jp_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.amazon_jp_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'shopee_id') {
        if (this.shopeeIdLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.shopee_id_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.shopee_id_cat_list).forEach((v) => {
              this.loginInfo.shopee_id_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.shopee_id_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'shopee_th') {
        if (this.shopeeThLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.shopee_th_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.shopee_th_cat_list).forEach((v) => {
              this.loginInfo.shopee_th_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.shopee_th_cat_list
            ).then((res) => {
              // console.log(res)
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'shopee_vn') {
        if (this.shopeeVnLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.shopee_vn_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.shopee_vn_cat_list).forEach((v) => {
              this.loginInfo.shopee_vn_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.shopee_vn_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'shopee_my') {
        if (this.shopeeMyLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.shopee_my_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.shopee_my_cat_list).forEach((v) => {
              this.loginInfo.shopee_my_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.shopee_my_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'shopee_ph') {
        if (this.shopeePhLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.shopee_ph_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.shopee_ph_cat_list).forEach((v) => {
              this.loginInfo.shopee_ph_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.shopee_ph_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'shopee_sg') {
        if (this.shopeeSgLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.shopee_sg_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.shopee_sg_cat_list).forEach((v) => {
              this.loginInfo.shopee_sg_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.shopee_sg_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'lazada_my') {
        if (this.lazadaMyLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.lazada_my_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.lazada_my_cat_list).forEach((v) => {
              this.loginInfo.lazada_my_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.lazada_my_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'lazada_sg') {
        if (this.lazadaSgLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.lazada_sg_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.lazada_sg_cat_list).forEach((v) => {
              this.loginInfo.lazada_sg_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.lazada_sg_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'lazada_id') {
        if (this.lazadaIdLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.lazada_id_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.lazada_id_cat_list).forEach((v) => {
              this.loginInfo.lazada_id_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.lazada_id_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'lazada_ph') {
        if (this.lazadaPhLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.lazada_ph_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.lazada_ph_cat_list).forEach((v) => {
              this.loginInfo.lazada_ph_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.lazada_ph_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'lazada_th') {
        if (this.lazadaThLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.lazada_th_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.lazada_th_cat_list).forEach((v) => {
              this.loginInfo.lazada_th_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.lazada_th_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.plat == 'lazada_vn') {
        if (this.lazadaVnLoginCatList == 'all') {
          arrs = this.catsData.result.bigCategory
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(arrs).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        } else {
          let isAll = false
          if (this.loginInfo.lazada_vn_cat_list.cat_id == 'all') {
            isAll = true
          } else {
            Object.keys(this.loginInfo.lazada_vn_cat_list).forEach((v) => {
              this.loginInfo.lazada_vn_cat_list[v].forEach((o, i) => {
                let parents = this.get_parents(o.cat_id)
                arrs.push(_.last(parents))
              })
            })
          }
          if (arrs.length == 0) {
            if (this.loginInfo.is_validata_user_count) {
              isAll = true
            }
          }
          if (isAll) {
            arrs = this.catsData.result.bigCategory
          }
          if (window.treeObj[this.plat].length > 0) {
            setTimeout(() => {
              this.zNodes = window.treeObj[this.plat]
              this.isDisabled = false
              this.initSelectzTree()
            }, 200)
          } else {
            this.startWorker(
              arrs,
              isAll ? 'all' : this.loginInfo.lazada_vn_cat_list
            ).then((res) => {
              this.zNodes = res
              this.isDisabled = false
              window.treeObj[this.plat] = res
              this.initSelectzTree()
            })
          }
        }
      } else if (this.type == 'social') {
        let cat_list = this.loginInfo.cat_list
        let isAll = false
        if (
          this.loginCatList == 'all' ||
          cat_list.cat_id == 'all' ||
          cat_list == 'all'
        ) {
          isAll = true
        } else {
          Object.keys(cat_list).forEach((v) => {
            cat_list[v].forEach((o, i) => {
              let parents = this.get_parents(o.cat_id)
              arrs.push(_.last(parents))
            })
          })
          let social_cat_list = this.loginInfo.social_cat_list
          arrs = arrs.filter((item) => social_cat_list.includes(item))
          if (arrs.length == this.loginInfo.social_cat_list.length) {
            arrs.push('0')
          }
        }
        if (isAll) {
          arrs = _.cloneDeep(this.loginInfo.social_cat_list)
          arrs.push('0')
        }
        if (arrs.length == 0) {
          if (this.loginInfo.is_validata_user_count) {
            isAll = true
            arrs = _.cloneDeep(this.loginInfo.social_cat_list)
            arrs.push('0')
          }
        }
        if (this.loginInfo.chance_social) {
          isAll = true
          arrs = _.cloneDeep(this.loginInfo.social_cat_list)
          arrs.push('0')
        }
        this.startWorker(arrs, isAll ? 'all' : cat_list).then((res) => {
          this.zNodes = res
          this.isDisabled = false
          window.treeObj[this.plat] = res
          this.initSelectzTree()
        })
      } else {
        let cat_list
        switch (this.plat) {
          case 'jd':
            cat_list = this.loginInfo.jd_cat_list
            break
          case 'chance_jd':
            cat_list = this.loginInfo.chance_jd_cat_list
            break
          case 'chance_all':
            cat_list = this.loginInfo.chance_cat_list
            break
          case 'douyin':
            cat_list = this.loginInfo.douyin_cat_list
            break
          default:
            cat_list = this.loginInfo.cat_list
        }
        let isAll = false
        if (cat_list.cat_id == 'all') {
          isAll = true
        } else {
          Object.keys(cat_list).forEach((v) => {
            cat_list[v].forEach((o, i) => {
              let parents = this.get_parents(o.cat_id)
              arrs.push(_.last(parents))
            })
          })
        }
        if (arrs.length == 0) {
          if (this.loginInfo.is_validata_user_count) {
            isAll = true
          }
        }
        if (isAll) {
          arrs = this.catsData.result.bigCategory
        }
        if (
          window.treeObj[this.plat].length > 0 &&
          this.plat !== 'chance_all'
        ) {
          setTimeout(() => {
            this.zNodes = window.treeObj[this.plat]
            this.isDisabled = false
            this.initSelectzTree()
          }, 200)
        } else {
          this.startWorker(arrs, isAll ? 'all' : cat_list).then((res) => {
            this.zNodes = res
            this.isDisabled = false
            window.treeObj[this.plat] = res
            this.initSelectzTree()
          })
        }
        // this.startWorker(arrs, cat_list).then(res => {
        //   this.zNodes = res;
        //   this.initSelectzTree()
        // })
        // this.zNodes = this.transformPickerOptions(arrs)
        // this.initSelectzTree()
        // },500)
      }
      this.placeholder = this.$t('headSearch.form_category_select')
    },
    initSelectzTree() {
      $.fn.zTree.init($('#' + this.treeDomId), this.setting, this.zNodes)
      // .expandAll(false)
      let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      const disabledNodes = zTree.getNodesByParam('disabled', true)
      disabledNodes.forEach((item) => {
        zTree.setChkDisabled(item, true)
      })
      this.selectOptions = []
      this.treeSelectedData = []
      this.zTreeObj = zTree
      // 处理没有任何类目权限用户,默认id为undefined,类目树不加载
      if (this.zTreeObj.getNodes().length == 0) {
        this.selectOptions = [
          {
            id: 1,
            name: '无权限',
          },
        ]
        if (this.multiple) {
          this.treeSelectedData = [1]
          this.$emit('change', this.treeSelectedData)
        } else {
          this.treeSelectedData = 1
          this.$emit('change', [this.treeSelectedData])
        }
        if (this.type != 'search') {
          this.$eventBus.$emit('loadingCats', false)
        }
        return
      }
      if (this.checkedKeys.length > 0 && this.checkedKeys[0] != '') {
        if (this.multiple) {
          for (const item of this.checkedKeys) {
            let node = zTree.getNodeByParam('id', item)
            this.selectOptions.push({
              id: node.id,
              name: node.label,
            })
            this.treeSelectedData.push(node.id)
            zTree.checkNode(node, true, true)
            zTree.selectNode(node)
          }
          this.$emit('change', this.treeSelectedData)
        } else {
          let node = zTree.getNodeByParam('id', this.checkedKeys[0])
          if (!node || node.disabled) {
            node = zTree.getNodes()[0]
            if (node.disabled) {
              node = this.getAllowedNode(node)
            }
          }
          this.selectOptions = [
            {
              id: node.id,
              name: node.label,
            },
          ]
          this.treeSelectedData = node.id
          this.$emit('change', [this.treeSelectedData])
          zTree.checkNode(node, true, true)
          zTree.selectNode(node)
        }
      } else {
        let node = null
        if (
          zTree.getNodes()[0].disabled == false ||
          zTree.getNodes()[0].disabled == undefined
        ) {
          node = zTree.getNodes()[0]
        } else {
          node = zTree.getNodesByParam('disabled', false)[0]
        }
        this.selectOptions = [
          {
            id: node.id,
            name: node.label,
          },
        ]
        if (this.multiple) {
          this.treeSelectedData = [node.id]
          this.$emit('change', this.treeSelectedData)
        } else {
          this.treeSelectedData = node.id
          this.$emit('change', [this.treeSelectedData])
        }

        zTree.checkNode(node, true, true)
        zTree.selectNode(node)
      }
      if (this.type != 'search') {
        this.$eventBus.$emit('loadingCats', false)
      }
    },
    getAllowedNode(node) {
      let resultNode = null
      const children = node.children
      children.forEach((item) => {
        if (!item.disabled) {
          resultNode = item
        }
      })
      if (resultNode) {
        return resultNode
      } else {
        return this.getAllowedNode(children[0])
      }
    },
    startWorker(cats, cat_list) {
      let lang = localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'zh'
      let langMode = localStorage.getItem('languageMode')
        ? localStorage.getItem('languageMode')
        : 'system'
      const actions = [
        {
          message: 'transformPickerOptions',
          func: function (
            cats,
            childrenList,
            cat_level_list,
            cat_list,
            plat,
            lang,
            langMode
          ) {
            return _transformPickerOptions(
              cats,
              childrenList,
              cat_level_list,
              cat_list,
              plat,
              lang,
              langMode
            )
            function _transformPickerOptions(
              _cats,
              _childrenList,
              cat_level_list,
              cat_list,
              plat,
              lang,
              langMode
            ) {
              let catArr = []
              for (let key in _cats) {
                let catId = _cats[key]

                if (cat_level_list == 'all' || cat_list == 'all') {
                  let { category_id, is_parent, chd, name, only_show, level } =
                    _childrenList[catId]
                  if (level == 4 && plat == 'jd') {
                    continue
                  }
                  let catLabel
                  if (
                    plat == 'all' ||
                    plat == 'chance_all' ||
                    plat == 'weibo' ||
                    plat == 'xhs' ||
                    plat == 'douyin' ||
                    plat == 'jd' ||
                    plat == 'chance_jd' ||
                    plat == 'tbjddy'
                  ) {
                    if (lang == 'zh') {
                      catLabel = childrenList[catId].name
                    } else if (lang == 'en') {
                      if (langMode == 'source') {
                        catLabel = childrenList[catId].name
                      } else if (langMode == 'both') {
                        if (childrenList[catId].name_en) {
                          catLabel =
                            childrenList[catId].name +
                            '/' +
                            childrenList[catId].name_en
                        } else {
                          catLabel =
                            childrenList[catId].name +
                            '/' +
                            childrenList[catId].category_name_en
                        }
                      } else {
                        if (childrenList[catId].name_en) {
                          catLabel = childrenList[catId].name_en
                        } else {
                          catLabel = childrenList[catId].category_name_en
                        }
                      }
                    }
                  } else if (
                    plat == 'gamazon' ||
                    plat == 'amazon_de' ||
                    plat == 'amazon_uk' ||
                    plat == 'amazon_jp' ||
                    plat == 'shopee_id' ||
                    plat == 'shopee_th' ||
                    plat == 'shopee_vn' ||
                    plat == 'shopee_my' ||
                    plat == 'shopee_ph' ||
                    plat == 'shopee_sg' ||
                    plat == 'lazada_id' ||
                    plat == 'lazada_th' ||
                    plat == 'lazada_vn' ||
                    plat == 'lazada_my' ||
                    plat == 'lazada_ph' ||
                    plat == 'lazada_sg'
                  ) {
                    if (lang == 'zh') {
                      if (langMode == 'source') {
                        catLabel = childrenList[catId].name_source
                      } else if (langMode == 'both') {
                        catLabel =
                          childrenList[catId].name +
                          '/' +
                          childrenList[catId].name_source
                      } else {
                        catLabel = childrenList[catId].name
                      }
                    } else {
                      if (langMode == 'source') {
                        catLabel = childrenList[catId].name_source
                      } else if (langMode == 'both') {
                        if (childrenList[catId].name_en) {
                          catLabel =
                            childrenList[catId].name_en +
                            '/' +
                            childrenList[catId].name_source
                        } else {
                          catLabel =
                            childrenList[catId].category_name_en +
                            '/' +
                            childrenList[catId].name_source
                        }
                      } else {
                        if (childrenList[catId].name_en) {
                          catLabel = childrenList[catId].name_en
                        } else {
                          catLabel = childrenList[catId].category_name_en
                        }
                      }
                    }
                  }
                  let _cat = {
                    id: category_id,
                    label: catLabel,
                    disabled: only_show,
                    is_parent,
                  }
                  if (is_parent) {
                    let _children = _transformPickerOptions(
                      chd,
                      _childrenList,
                      cat_level_list,
                      cat_list,
                      plat,
                      lang,
                      langMode
                    )
                    if (_children.length) {
                      _cat.children = _children
                    }
                  }
                  catArr.push(_cat)
                } else {
                  // if (plat == 'gamazon') {
                  //   let {
                  //     category_id,
                  //     is_parent,
                  //     chd,
                  //     name,
                  //     only_show,
                  //     level,
                  //   } = _childrenList[catId]
                  //   let cat = {
                  //     id: category_id,
                  //     label: childrenList[catId].category_name_en,
                  //     disabled: only_show,
                  //     is_parent,
                  //   }
                  //   catArr.push(cat)
                  //   continue
                  // }
                  if (_childrenList[catId]) {
                    let {
                      category_id,
                      is_parent,
                      chd,
                      name,
                      only_show,
                      level,
                    } = _childrenList[catId]
                    if (level == 4 && plat == 'jd') {
                      continue
                    }
                    only_show = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[1]
                    let has_priv = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[0]
                    let _cat = null
                    if (has_priv) {
                      let catLabel
                      if (
                        plat == 'all' ||
                        plat == 'chance_all' ||
                        plat == 'weibo' ||
                        plat == 'xhs' ||
                        plat == 'douyin' ||
                        plat == 'jd' ||
                        plat == 'chance_jd' ||
                        plat == 'tbjddy'
                      ) {
                        if (lang == 'zh') {
                          catLabel = childrenList[catId].name
                        } else if (lang == 'en') {
                          if (langMode == 'source') {
                            catLabel = childrenList[catId].name
                          } else if (langMode == 'both') {
                            if (childrenList[catId].name_en) {
                              catLabel =
                                childrenList[catId].name +
                                '/' +
                                childrenList[catId].name_en
                            } else {
                              catLabel =
                                childrenList[catId].name +
                                '/' +
                                childrenList[catId].category_name_en
                            }
                          } else {
                            if (childrenList[catId].name_en) {
                              catLabel = childrenList[catId].name_en
                            } else {
                              catLabel = childrenList[catId].category_name_en
                            }
                          }
                        }
                      } else if (
                        plat == 'gamazon' ||
                        plat == 'amazon_de' ||
                        plat == 'amazon_uk' ||
                        plat == 'amazon_jp' ||
                        plat == 'shopee_id' ||
                        plat == 'shopee_th' ||
                        plat == 'shopee_vn' ||
                        plat == 'shopee_my' ||
                        plat == 'shopee_ph' ||
                        plat == 'shopee_sg' ||
                        plat == 'lazada_id' ||
                        plat == 'lazada_th' ||
                        plat == 'lazada_vn' ||
                        plat == 'lazada_my' ||
                        plat == 'lazada_ph' ||
                        plat == 'lazada_sg'
                      ) {
                        if (lang == 'zh') {
                          if (langMode == 'source') {
                            catLabel = childrenList[catId].name_source
                          } else if (langMode == 'both') {
                            catLabel =
                              childrenList[catId].name +
                              '/' +
                              childrenList[catId].name_source
                          } else {
                            catLabel = childrenList[catId].name
                          }
                        } else {
                          if (langMode == 'source') {
                            catLabel = childrenList[catId].name_source
                          } else if (langMode == 'both') {
                            if (childrenList[catId].name_en) {
                              catLabel =
                                childrenList[catId].name_en +
                                '/' +
                                childrenList[catId].name_source
                            } else {
                              catLabel =
                                childrenList[catId].category_name_en +
                                '/' +
                                childrenList[catId].name_source
                            }
                          } else {
                            if (childrenList[catId].name_en) {
                              catLabel = childrenList[catId].name_en
                            } else {
                              catLabel = childrenList[catId].category_name_en
                            }
                          }
                        }
                      }
                      _cat = {
                        id: category_id,
                        label: catLabel,
                        disabled: only_show == true,
                        is_parent: is_parent,
                      }
                    } else {
                      continue
                    }
                    if (is_parent) {
                      let _children = _transformPickerOptions(
                        chd,
                        _childrenList,
                        cat_level_list,
                        cat_list,
                        plat,
                        lang,
                        langMode
                      )
                      if (_children.length) {
                        _cat.children = _children
                      }
                    }
                    // 如果前面类目父类已经添加,就不要重复添加
                    let index = catArr.findIndex((item) => {
                      return item.id == _cat.id
                    })
                    if (index > -1) {
                      continue
                    } else {
                      catArr.push(_cat)
                    }
                  } else {
                    continue
                  }
                }
              }
              return catArr
            }
            function check_permission(cid, __childrenList, cat_list) {
              let pids = get_parents(cid, __childrenList)
              let has_priv = false,
                only_show = true
              //1.父类目是否有权限
              pids.forEach(function (pid, i) {
                let cat = __childrenList[pid]
                let level = cat.level
                cat_list['level' + level].forEach(function (o, j) {
                  if (o.cat_id == pid) {
                    has_priv = true
                    only_show = false
                  }
                })
              })
              //2.子类目有权限的，需展示父类目
              if (!has_priv) {
                Object.keys(cat_list).forEach(function (v) {
                  cat_list[v].forEach(function (o, i) {
                    let parents = get_parents(o.cat_id, __childrenList)
                    if (parents.indexOf(cid) >= 0) {
                      has_priv = true
                      only_show = true
                    }
                  })
                })
              } else {
                only_show = false
              }

              return [has_priv, only_show]
            }
            function get_parents(cid, ___childrenList) {
              let cat = ___childrenList[cid]
              let pids = [cid]
              while (cat && cat.parent_id != '0') {
                pids.push(cat.parent_id)
                cat = ___childrenList[cat.parent_id]
              }
              return pids
            }
          },
        },
      ]
      let worker = this.$worker.create(actions)
      let postMessageActionName = 'transformPickerOptions'
      let loginCatList = this.loginCatList
      if (this.plat == 'gamazon') {
        loginCatList = this.amazonLoginCatList
      } else if (this.plat == 'amazon_de') {
        loginCatList = this.amazonDeLoginCatList
      } else if (this.plat == 'amazon_uk') {
        loginCatList = this.amazonUkLoginCatList
      } else if (this.plat == 'amazon_jp') {
        loginCatList = this.amazonJpLoginCatList
      } else if (this.plat == 'shopee_id') {
        loginCatList = this.shopeeIdLoginCatList
      } else if (this.plat == 'shopee_th') {
        loginCatList = this.shopeeThLoginCatList
      } else if (this.plat == 'shopee_vn') {
        loginCatList = this.shopeeVnLoginCatList
      } else if (this.plat == 'shopee_my') {
        loginCatList = this.shopeeMyLoginCatList
      } else if (this.plat == 'shopee_ph') {
        loginCatList = this.shopeePhLoginCatList
      } else if (this.plat == 'shopee_sg') {
        loginCatList = this.shopeeSgLoginCatList
      } else if (this.plat == 'lazada_my') {
        loginCatList = this.lazadaMyLoginCatList
      } else if (this.plat == 'lazada_sg') {
        loginCatList = this.lazadaSgLoginCatList
      } else if (this.plat == 'lazada_id') {
        loginCatList = this.lazadaIdLoginCatList
      } else if (this.plat == 'lazada_ph') {
        loginCatList = this.lazadaPhLoginCatList
      } else if (this.plat == 'lazada_th') {
        loginCatList = this.lazadaThLoginCatList
      } else if (this.plat == 'lazada_vn') {
        loginCatList = this.lazadaVnLoginCatList
      }
      return worker.postMessage(postMessageActionName, [
        cats,
        this.catsData.result.childrenList,
        loginCatList,
        cat_list,
        this.plat,
        lang,
        langMode,
      ])
    },
    transformPickerOptions(cats) {
      let self = this
      let childrenList = this.catsData.result.childrenList
      let lang = localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'zh'
      let langMode = localStorage.getItem('languageMode')
        ? localStorage.getItem('languageMode')
        : 'both'
      return _transformPickerOptions(cats)
      function _transformPickerOptions(_cats) {
        let resultArr = []
        for (let key in _cats) {
          let catId = _cats[key]
          if (self.loginCatList == 'all' || self.plat == 'gamazon') {
            let { category_id, is_parent, chd, name, only_show, level } =
              childrenList[catId]
            if (level == 4 && self.plat == 'jd') {
              continue
            }
            let catLabel
            if (
              plat == 'all' ||
              plat == 'chance_all' ||
              plat == 'weibo' ||
              plat == 'xhs' ||
              plat == 'douyin' ||
              plat == 'jd' ||
              plat == 'chance_jd' ||
              plat == 'tbjddy'
            ) {
              if (lang == 'zh') {
                catLabel = childrenList[catId].name
              } else if (lang == 'en') {
                if (langMode == 'source') {
                  catLabel = childrenList[catId].name
                } else if (langMode == 'both') {
                  if (childrenList[catId].name_en) {
                    catLabel =
                      childrenList[catId].name +
                      '/' +
                      childrenList[catId].name_en
                  } else {
                    catLabel =
                      childrenList[catId].name +
                      '/' +
                      childrenList[catId].category_name_en
                  }
                } else {
                  if (childrenList[catId].name_en) {
                    catLabel = childrenList[catId].name_en
                  } else {
                    catLabel = childrenList[catId].category_name_en
                  }
                }
              }
            } else if (
              plat == 'gamazon' ||
              plat == 'amazon_de' ||
              plat == 'amazon_uk' ||
              plat == 'amazon_jp' ||
              plat == 'shopee_id' ||
              plat == 'shopee_th' ||
              plat == 'shopee_vn' ||
              plat == 'shopee_my' ||
              plat == 'shopee_ph' ||
              plat == 'shopee_sg' ||
              plat == 'lazada_id' ||
              plat == 'lazada_th' ||
              plat == 'lazada_vn' ||
              plat == 'lazada_my' ||
              plat == 'lazada_ph' ||
              plat == 'lazada_sg'
            ) {
              if (lang == 'zh') {
                if (langMode == 'source') {
                  catLabel = childrenList[catId].name_source
                } else if (langMode == 'both') {
                  catLabel =
                    childrenList[catId].name +
                    '/' +
                    childrenList[catId].name_source
                } else {
                  catLabel = childrenList[catId].name
                }
              } else {
                if (langMode == 'source') {
                  catLabel = childrenList[catId].name_source
                } else if (langMode == 'both') {
                  if (childrenList[catId].name_en) {
                    catLabel =
                      childrenList[catId].name_en +
                      '/' +
                      childrenList[catId].name_source
                  } else {
                    catLabel =
                      childrenList[catId].category_name_en +
                      '/' +
                      childrenList[catId].name_source
                  }
                } else {
                  if (childrenList[catId].name_en) {
                    catLabel = childrenList[catId].name_en
                  } else {
                    catLabel = childrenList[catId].category_name_en
                  }
                }
              }
            }
            let _cat = {
              id: category_id,
              label: catLabel,
              disabled: only_show,
              is_parent,
              level,
            }
            if (is_parent) {
              let _children = _transformPickerOptions(chd)
              if (_children.length) {
                _cat.children = _children
              }
            }
            resultArr.push(_cat)
          } else {
            if (childrenList[catId]) {
              let { category_id, is_parent, chd, name, only_show, level } =
                childrenList[catId]
              if (level == 4 && self.plat == 'jd') {
                continue
              }
              only_show = self.check_permission(catId)[1]
              let has_priv = self.check_permission(catId)[0]
              let _cat = null
              if (has_priv) {
                let catLabel
                if (
                  plat == 'all' ||
                  plat == 'chance_all' ||
                  plat == 'weibo' ||
                  plat == 'xhs' ||
                  plat == 'douyin' ||
                  plat == 'jd' ||
                  plat == 'chance_jd' ||
                  plat == 'tbjddy'
                ) {
                  if (lang == 'zh') {
                    catLabel = childrenList[catId].name
                  } else if (lang == 'en') {
                    if (langMode == 'source') {
                      catLabel = childrenList[catId].name
                    } else if (langMode == 'both') {
                      if (childrenList[catId].name_en) {
                        catLabel =
                          childrenList[catId].name +
                          '/' +
                          childrenList[catId].name_en
                      } else {
                        catLabel =
                          childrenList[catId].name +
                          '/' +
                          childrenList[catId].category_name_en
                      }
                    } else {
                      if (childrenList[catId].name_en) {
                        catLabel = childrenList[catId].name_en
                      } else {
                        catLabel = childrenList[catId].category_name_en
                      }
                    }
                  }
                } else if (
                  plat == 'gamazon' ||
                  plat == 'amazon_de' ||
                  plat == 'amazon_uk' ||
                  plat == 'amazon_jp' ||
                  plat == 'shopee_id' ||
                  plat == 'shopee_th' ||
                  plat == 'shopee_vn' ||
                  plat == 'shopee_my' ||
                  plat == 'shopee_ph' ||
                  plat == 'shopee_sg' ||
                  plat == 'lazada_id' ||
                  plat == 'lazada_th' ||
                  plat == 'lazada_vn' ||
                  plat == 'lazada_my' ||
                  plat == 'lazada_ph' ||
                  plat == 'lazada_sg'
                ) {
                  if (lang == 'zh') {
                    if (langMode == 'source') {
                      catLabel = childrenList[catId].name_source
                    } else if (langMode == 'both') {
                      catLabel =
                        childrenList[catId].name_source +
                        '/' +
                        childrenList[catId].name
                    } else {
                      catLabel = childrenList[catId].name
                    }
                  } else {
                    if (langMode == 'source') {
                      catLabel = childrenList[catId].name_source
                    } else if (langMode == 'both') {
                      if (childrenList[catId].name_en) {
                        catLabel =
                          childrenList[catId].name_en +
                          '/' +
                          childrenList[catId].name_source
                      } else {
                        catLabel =
                          childrenList[catId].category_name_en +
                          '/' +
                          childrenList[catId].name_source
                      }
                    } else {
                      if (childrenList[catId].name_en) {
                        catLabel = childrenList[catId].name_en
                      } else {
                        catLabel = childrenList[catId].category_name_en
                      }
                    }
                  }
                }
                _cat = {
                  id: category_id,
                  label: catLabel,
                  disabled: only_show == true,
                  is_parent: is_parent,
                  level,
                }
              } else {
                continue
              }
              if (is_parent) {
                let _children = _transformPickerOptions(chd)
                if (_children.length) {
                  _cat.children = _children
                }
              }
              // 如果前面类目父类已经添加,就不要重复添加
              let index = resultArr.findIndex((item) => {
                return item.id == _cat.id
              })
              if (index > -1) {
                continue
              } else {
                resultArr.push(_cat)
              }
            } else {
              continue
            }
          }
        }
        return resultArr
        // return _.compact(
        //   _.map(_cats, function (catId) {
        //     if (self.loginCatList == 'all'){
        //       let { category_id, is_parent, chd, name, only_show,level } =
        //         childrenList[catId]
        //       if(level == 4 && self.plat=='jd'){
        //         return
        //       }
        //       let _cat = {
        //         value: category_id,
        //         label: name,
        //         disabled: only_show,
        //         is_parent
        //       };
        //       if (is_parent) {
        //         let _children = _transformPickerOptions(chd)
        //         if (_children.length) {
        //           _cat.children = _children
        //         }
        //       }
        //       return _cat
        //     }else{
        //       if (childrenList[catId]) {
        //         let { category_id, is_parent, chd, name, only_show,level } =
        //           childrenList[catId]
        //         if(level == 4 && self.plat=='jd'){
        //           return
        //         }
        //         only_show = self.check_permission(catId)[1]
        //         let has_priv = self.check_permission(catId)[0]
        //         let _cat = null
        //         if (has_priv) {
        //           _cat = {
        //             value: category_id,
        //             label: name,
        //             disabled: only_show == true,
        //             is_parent: is_parent,
        //           }
        //         } else {
        //           return
        //         }
        //         if (is_parent) {
        //           let _children = _transformPickerOptions(chd)
        //           if (_children.length) {
        //             _cat.children = _children
        //           }
        //         }
        //         return _cat
        //       } else {
        //         return false
        //       }
        //     }

        //   })
        // )
      }
    },
    check_permission(cid) {
      let self = this
      let childrenList = this.catsData.result.childrenList
      let pids = this.get_parents(cid)
      let has_priv = false,
        only_show = true
      const cat_list =
        this.plat == 'jd' ? self.loginInfo.jd_cat_list : self.loginInfo.cat_list
      //1.父类目是否有权限
      pids.forEach(function (pid, i) {
        let cat = childrenList[pid]
        let level = cat.level
        cat_list['level' + level].forEach(function (o, j) {
          if (o.cat_id == pid) {
            has_priv = true
            only_show = false
          }
        })
      })
      //2.子类目有权限的，需展示父类目
      if (!has_priv) {
        Object.keys(cat_list).forEach(function (v) {
          cat_list[v].forEach(function (o, i) {
            let parents = self.get_parents(o.cat_id)
            if (parents.indexOf(cid) >= 0) {
              has_priv = true
              only_show = true
            }
          })
        })
      } else {
        only_show = false
      }

      return [has_priv, only_show]
    },
    get_parents(cid) {
      let childrenList = this.catsData.result.childrenList
      let cat = childrenList[cid]
      let pids = [cid]
      while (cat.parent_id != '0') {
        pids.push(cat.parent_id)
        cat = childrenList[cat.parent_id]
      }
      return pids
    },
    getCatPath(cid) {
      let that = this
      let path = getParent(cid)
      if (that.maxLevel > path.length && !that.isPc) {
        path = path.concat(_.fill(Array(that.maxLevel - path.length), '-'))
      }
      return path
      function getParent(cid, path = [cid]) {
        if (
          this.catsData.result.childrenList[cid] &&
          this.catsData.result.childrenList[cid].parent_id
        ) {
          if (this.catsData.result.childrenList[cid].parent_id !== '0') {
            let parentId = this.catsData.result.childrenList[cid].parent_id
            return getParent(parentId, _.concat([parentId], path))
          } else {
            return path
          }
        } else {
          return [cid]
        }
      }
    },
    removeTag(val) {
      let zTree = $.fn.zTree.getZTreeObj(this.treeDomId)
      let node = zTree.getNodeByParam('id', val)
      zTree.checkNode(node, false, true)
      zTree.cancelSelectedNode(node)
    },
    /*
      cats: [id]
    */
    getPermisstionDate(cats) {
      let datas
      switch (this.plat) {
        case 'jd':
          datas = this.$store.state.user.jdLoginCatlevel
          break
        case 'chance_jd':
          datas = this.$store.state.user.chanceJdLoginCatlevel
          break
        case 'chance_all':
          datas = this.$store.state.user.chanceLoginCatlevel
          break
        case 'all':
          datas = this.$store.state.user.loginCatlevel
          break
        default:
          datas = this.$store.state.user.loginCatlevel
      }
      // this.plat == 'jd'
      //   ? this.$store.state.user.jdLoginCatlevel
      //   : this.$store.state.user.loginCatlevel
      let times = []
      cats.forEach((item) => {
        let id = item
        let node = this.zTreeObj.getNodeByParam('id', item)
        let index = datas.findIndex((item) => item.cat_id == id)
        while (index == -1) {
          node = node.getParentNode()
          if (!node) break
          id = node.id
          index = datas.findIndex((item) => item.cat_id == id)
        }
        if (index !== -1 && datas[index]) {
          times.push(datas[index].ts)
        }
      })
      return times
    },
    getCatNameById(cid) {
      const node = this.zTreeObj.getNodeByParam('id', cid)
      if (!node) return
      return node.label
    },
  },
}
</script>

<style lang="less">
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
}
.common-tree {
  overflow: auto;
}

ul {
  padding: 0 0 0 10px;
}
.ztreePopover {
  .el-select .el-tag {
    max-width: 120px;
  }
}
</style>

<style>
</style>
